/**
 * ToolTip Template Utils
 *
 * @since 2018-12-07
 * @author kdydesign.kim
 */

// 도메인 객체 tooltip 템플릿
export function domainObjectToolTipFormat (res, version) {
  // TAMS
  const
    key = Number(version) === 4 ? 'ipv4_ip_list' : 'ipv6_ip_list',
    list = (res[key] !== null) ? res[key].split(',') : [],
    ip = _.map(_.take(list, 10), ip => ip)

  // TAMS
  const rIp = _.get(list, ['length'], 0) > 10 ? _.concat(ip, ['...']) : ip

  if (rIp.length === 0) {
    return _.concat(
      _.truncate(res.addr_obj_uname, {length: 53}),
      _.truncate(res.domain_name, {length: 53}),
      res.addr_obj_desc
    )
  }

  return _.concat(
    _.truncate(res.addr_obj_uname, {length: 53}),
    _.truncate(res.domain_name, {length: 53}),
    rIp,
    res.addr_obj_desc
  )
}

// 그룹 객체 안에 포함된 도메인 객체 tooltip 템플릿
export function groupInDomainObjectToolTipFormat (res, version) {
  // TAMS
  const ip = _.filter(_.split(res.addr_obj_domain_ip_list, ','), ip => ip.indexOf(version === 4 ? '.' : ':') !== -1)

  const rIp = ip.length > 5 ? `${_.take(ip, 5)}...` : ip.join(',')

  return `${_.truncate(res.addr_obj_uname, {length: 53})} ${rIp}`
}
